  <du-lipo-detail [detailModel]="detailModel"
                  (onSaveClicked)="onSaveClick(detailModel!)"
                  (onDeleteClicked)="onDeleteClick()"
                  [headerButtons]="headerButtons"
                  [navigateBack]="{commands: [LipoRouteEnum.SYSTEM, systemId, LipoRouteEnum.TENANT, tenantId]}"></du-lipo-detail>
